import { useEffect, useState } from "react";
import { BUDGET_ORGANIZATIONS } from "../constants/organizations";
import {
  getStoredBudgetOrganizationView,
  setStoredBudgetOrganizationView,
} from "./BudgetOrganizationSwitcher";

const selectStyle = {
  padding: "8px 12px",
  borderRadius: 10,
  border: "1px solid #a9ddf5",
  background: "#EAF6FD",
  fontWeight: 700,
  fontSize: "0.85rem",
  color: "#2C63AE",
  minWidth: 0,
  cursor: "pointer",
};

function FilterField({ label, children }) {
  return (
    <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: "0.72rem", fontWeight: 700, color: "#2C8FC7" }}>
      {label}
      {children}
    </label>
  );
}

/**
 * Period / year / organisation filters for Budget.
 *
 * Department is deliberately absent: it is chosen in the department bar at the
 * top of the page like everywhere else, and Budget re-queries from the
 * `departmentViewChanged` event that emits.
 */
export default function BudgetScopeFilters({ organizationView, onOrganizationChange }) {
  const [org, setOrg] = useState(organizationView ?? getStoredBudgetOrganizationView());

  useEffect(() => {
    setOrg(organizationView ?? getStoredBudgetOrganizationView());
  }, [organizationView]);


  const handleOrg = (next) => {
    setOrg(next);
    setStoredBudgetOrganizationView(next);
    onOrganizationChange?.(next);
    window.dispatchEvent(new CustomEvent("budgetOrganizationViewChanged", { detail: next }));
  };


  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "flex-end", justifyContent: "flex-end" }}>
      <FilterField label="Organisation">
        <select value={org} onChange={(e) => handleOrg(e.target.value)} style={{ ...selectStyle, minWidth: 140 }}>
          <option value="">All organisations</option>
          {BUDGET_ORGANIZATIONS.map((o) => (
            <option key={o} value={o}>{o}</option>
          ))}
        </select>
      </FilterField>
    </div>
  );
}

export { selectStyle, FilterField };
